<div class="layout-footer">
    <div class="p-grid">
        <div class="p-col-12 p-md-6  p-lg-3">
            <span class="logo">Brain Monitor</span>
            <p> </p>
        </div>
    </div>
</div>
